import CrownIcon from 'assets/Icons/CrownIcon';
import CrownV2Icon from 'assets/SubscriptionPricing/CrownV2Icon';
import React from 'react';

import PriceContainer from '@/components/HomePage/SubscriptionPricing/PriceContainer';

const SubscriptionPricing = () => {
  const monthlySubscriptionUrl =
    process.env.NEXT_PUBLIC_PRIME_LINK ||
    'https://zbrlrn.com/9Xvat';

  const yearlySubscriptionUrl =
    process.env.NEXT_PUBLIC_PRIME_PLUS_LINK ||
    'https://zbrlrn.com/9Xvat';

  return (
    <div className='relative px-4 md:px-5 lg:px-6 xl:px-12 flex justify-center bg-subscription-bg md:bg-cover bg-inherit bg-center'>
      <div
        style={{
          background: `linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.9) 100%), linear-gradient(180deg, rgba(18,18,18,0.8) 0%, var(--black-shades-100, #000) 100%)`,
        }}
        className='absolute top-0 left-0 w-full h-full'
      ></div>
      <div className='z-[9] flex pt-16 pb-8 xl:flex-nowrap md:flex-wrap flex-wrap '>
        <div className='max-w-lg w-full md:me-10 me-0 xl:mb-0 md:mb-9 mb-9'>
          <div className='flex items-center gap-3.5 md:mb-6 mb-3'>
            <CrownIcon className='w-10 h-10' />
            <p className='uppercase text-xl font-bold  text-transparent bg-clip-text bg-gradient-to-t from-[#FFCEA1] to-[#997C61]'>
              Gold
            </p>
          </div>
          <p className='md:text-3xl text-xl text-white font-semibold md:mb-5 mb-2 text-left'>
            Smarter Learning Starts With the Right Plan
          </p>
          <p className='font-normal text-white md:text-lg text-sm text-left md:mb-6 mb-5'>
            Unlock exclusive features, smarter tools, and personalized learning
            paths.
          </p>
          <div className='flex flex-col gap-4'>
            <div className='flex items-center gap-2.5'>
              <CrownV2Icon className='w-5 h-4' />
              <p className='text-sm text-white/80'>
                <span className='text-white font-semibold'>
                  No auto-renewal
                </span>{' '}
                without your consent
              </p>
            </div>
            <div className='flex items-center gap-2.5'>
              <CrownV2Icon className='w-5 h-4' />
              <p className='text-sm text-white/80'>
                Unlock all app{' '}
                <span className='text-white font-semibold'>
                  premium features
                </span>
              </p>
            </div>
            <div className='flex items-center gap-2.5'>
              <CrownV2Icon className='w-5 h-4' />
              <p className='text-sm text-white/80'>
                Access on{' '}
                <span className='text-white font-semibold'>any device</span>
              </p>
            </div>
            <div className='flex items-center gap-2.5'>
              <CrownV2Icon className='w-5 h-4' />
              <p className='text-sm text-white/80'>
                <span className='text-white font-semibold'>
                  Unlimited access
                </span>{' '}
                of books
              </p>
            </div>
          </div>
        </div>
        <div className='flex md:flex-nowrap flex-wrap gap-10'>
          <PriceContainer
            title=''
            price='600'
            durationText="/Month"
            redirectUrl={monthlySubscriptionUrl}
            list={[
              { check: true, title: 'eBooks (Unlimited Access)' },
              { check: true, title: 'Video Summary' },
              { check: true, title: 'AudioBooks' },
              { check: true, title: 'Certification' },
              { check: true, title: 'App Access' },
              { check: false, title: 'Upgrade to Hardcopy' },
            ]}
            valueForMoney={false}
          />
          <PriceContainer
            valueForMoney={true}
            title=''
            price='4999'
            durationText="/Year"
            redirectUrl={yearlySubscriptionUrl}
            list={[
              { check: true, title: 'eBooks (Unlimited Access)' },
              { check: true, title: 'Video Summary' },
              { check: true, title: 'AudioBooks' },
              { check: true, title: 'Certification' },
              { check: true, title: 'App Access' },
              { check: true, title: '25% Off On All Hardcopy' },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPricing;
